import DeletedItem from "../DeletedItem/DeletedItem";
import "./DeletedRecords.css";
import { useEffect } from "react";
import { useRecords } from "../../hooks/useRecords";
// import { getRecordsDb } from '../../controllers/getRecords';
import { getDeletedRecordsDb } from "../../controllers/getDeletedRecords";
import { IRecord } from "../../interfaces/interfaces";

const DeletedRecords = () => {
  // const { records, getRecords } = useRecords();
  const { deletedRecords, getDeletedRecords } = useRecords();

  useEffect(() => {
    if (deletedRecords.length === 0) {
      getDeletedRecordsDb().then((response) => {
        if (response) {
          getDeletedRecords(response);
        }
      });
    }
  }, []);

  return (
    <div
      className="Deleted-List-box"
      style={
        deletedRecords.length > 5
          ? { overflowY: "scroll" }
          : { overflowY: "visible" }
      }
    >
      {deletedRecords.length > 0 &&
        deletedRecords.map((record: IRecord) => {
          return <DeletedItem key={record._id} record={record} />;
        })}
    </div>
  );
};
export default DeletedRecords;
